import {Component, OnInit} from '@angular/core';
import {DialogType, FSInvoiceDialogService} from '~/app/core/services/fsinvoice.dialog.service';
import {UserService} from '~/app/core/services/user.service';
import {Router} from '@angular/router';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {StoreApGlXrefService} from '~/app/core/services/store-ap-gl-xref.service';
import {AuthServicesService} from 'mclane-webauth-lib';
import {Store} from '@model/Store';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {HomeOffice} from '@model/HomeOffice';
import {StoreConfigService} from '~/app/core/services/store-config.service';
import {FileName} from '@model/FileName';
import {StoreConfig} from '@model/StoreConfig';
import {Segments} from '@model/Segments';
import {AddSegmentComponent} from '~/app/web/setup/store-config/add-segment/add-segment.component';
import {SystemConfig} from '@model/SystemConfig';
import {Package} from '@model/Package';
import { NotificationService } from '@progress/kendo-angular-notification';
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';
import { lastValueFrom } from 'rxjs';
@Component({
  selector: 'app-store-config',
  templateUrl: './store-config.component.html',
  styleUrls: ['./store-config.component.scss']
})
export class StoreConfigComponent implements OnInit {
  public selectedStore: Store;
  storeList: Store[] = [];
  public selectedHomeOffice: HomeOffice;


  selectedPackageName: Package;

  public gridDataFileNames: any = [];
  public mySelectionFileNames: string[] = [];
  public fileNames: FileName[] = [];
  public selectedFiles: FileName[] = [];


  public gridDataSegments: any = [];
  public mySelectionSegments: any[] = [];


  public storeConfigs: StoreConfig[] = [];
  public systemConfig: SystemConfig = new SystemConfig();
  public selectedStoreConfig: StoreConfig[] = [];
  public selectedSystemConfig: SystemConfig;

  voiceLine: any;
  address: any;
  dataLine: any;
  city: any;
  chain: any;
  state: any;
  zip: any;
  primaryDC: any;
  defaultGL: any;
  discountGL: any;
  surchargeGL: any;
  salesTaxGL: any;
  apAccount: any;
  division: any;
  site: any;
  foodVendor: any;
  equipmentVendor: any;
  departmentNumber: any;
  locationNumber: any;
  segments: Segments[];
  segmentSeparator: any;
  exportWithSaparator: boolean;
  public apExportSum: boolean = false;
  public packageNameList: Package[] = [];
  public storeName: string = '';
  public placeHolder: Package;
  pkgOld: String = '';
  moduleOld: String = '';
  newPkg: String = '';

  public newSegment: Segments = new Segments();
  newSegmentArray: Segments[] = [];

  constructor(public dialogService: FSInvoiceDialogService,
              public loadingIndicator: LoadingIndicatorHelper,
              public userService: UserService,
              public router: Router,
              public authService: AuthServicesService,
              public localStorage: LocalStorageIndexedService,
              public storeApGlXrefService: StoreApGlXrefService,
              public storeConfigService: StoreConfigService,
              private notificationService: NotificationService) {
  }

  public show(content: string): void {
    this.notificationService.show({
      content: content,
      position: { horizontal: "center", vertical: "bottom" },
      animation: { type: "fade", duration: 400 },
      type: { style: "warning", icon: true },
      closable: true,
      hideAfter: 4000
    });
  }

  public selectedCallbackFileNames = (args) => args.dataItem;
  public selectedCallbackSegments = (args) => args.dataItem;

  async ngOnInit() {
    this.loadingIndicator.show();

    this.placeHolder = {
      assigned: false,
      hoId: 0,
      pkg: "Select Package...",
      display: ""
    }
    if (this.userService.selectedHomeOffice === undefined) {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== undefined && this.localStorage.getFromSession(AppEnums.HOME_OFFICE) !== null) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.storeList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
        this.storeList.forEach(store => {
          store.display = store.chainID + ' - ' + store.storeID;
        });
        this.loadingIndicator.hide();
      } else {
        this.loadingIndicator.hide();
        this.dialogService.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    } else {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
      this.storeList = await this.storeApGlXrefService.getStoreList(this.selectedHomeOffice.hoId, this.authService.getUsername().toUpperCase());
      this.storeList.forEach(store => {
        store.display = store.chainID + ' - ' + store.storeID;
      });
      this.loadingIndicator.hide();
    }
    if (this.storeList.length > 0) {
      this.selectedStore = this.storeList[0];
      await this.storeValueChange(this.selectedStore);
    } else {
      this.show('No Active Stores for User');
    }

    this.loadingIndicator.hide();
  }

  async populateConfig(store: Store) {
    this.loadingIndicator.show();
    this.systemConfig = await this.storeConfigService.getSystemConfig(store.hoID);
    this.selectedSystemConfig = this.systemConfig;

    this.apExportSum = this.selectedSystemConfig.apExportSum;

    this.storeConfigs = await this.storeConfigService.getStoreConfig(store.hoID, this.authService.getUsername());
    this.selectedStoreConfig = this.storeConfigs.filter(store => store.store === this.selectedStore.storeID);

    this.storeName = this.selectedStoreConfig[0].storeName + ' ';
    this.voiceLine = this.selectedStoreConfig[0].voiceLine + ' ';
    this.address = this.selectedStoreConfig[0].address + ' ';
    this.dataLine = this.selectedStoreConfig[0].dataLine + ' ';
    this.city = this.selectedStoreConfig[0].city + ' ';
    this.chain = this.selectedStoreConfig[0].chain + ' ';
    this.state = this.selectedStoreConfig[0].state + ' ';
    this.zip = this.selectedStoreConfig[0].zip + ' ';
    this.primaryDC = this.selectedStoreConfig[0].primaryDC + ' ';
    this.defaultGL = this.selectedStoreConfig[0].defaultGL + ' ';
    this.discountGL = this.selectedStoreConfig[0].discountGL + ' ';
    this.surchargeGL = this.selectedStoreConfig[0].surchargeGL + ' ';
    this.salesTaxGL = this.selectedStoreConfig[0].salesTaxGL + ' ';
    this.apAccount = this.selectedStoreConfig[0].apAccount + ' ';
    this.division = this.selectedStoreConfig[0].division + ' ';
    this.site = this.selectedStoreConfig[0].site + ' ';
    this.foodVendor = this.selectedStoreConfig[0].foodVendor + ' ';
    this.equipmentVendor = this.selectedStoreConfig[0].equipmentVendor + ' ';
    this.departmentNumber = this.selectedStoreConfig[0].departmentNumber + ' ';
    this.locationNumber = this.selectedStoreConfig[0].locationNumber + ' ';
    this.segments = this.selectedStoreConfig[0].segments;
    this.exportWithSaparator = this.selectedStoreConfig[0].exportWithSaparator;
    this.segmentSeparator = this.selectedStoreConfig[0].segmentSeparator + ' ';

    this.gridDataSegments = this.segments;

    let minSeglength = 0;
    this.segments.forEach(seg => {
      minSeglength = minSeglength + seg.length;
    });

    this.localStorage.setToSession(AppEnums.MIN_SEG_LENGTH, minSeglength);

    this.storeConfigService.getPackageNames().then(packageNameList => {
      this.packageNameList = packageNameList;
      if (this.packageNameList.length > 0) {
        this.packageNameList.filter(p => {
          if (p.assigned === true) {
            this.selectedPackageName = p;
          }
        });
        if(this.selectedPackageName) {
          this.packageNameValueChange(this.selectedPackageName);
          this.moduleOld = "AP";
          this.pkgOld = this.selectedPackageName.pkg;
        }
      }
    });
    this.loadingIndicator.hide();
  }

  save() {
    this.selectedSystemConfig.apExportSum = this.apExportSum;
    this.selectedStoreConfig[0].storeName = this.storeName;
    this.selectedStoreConfig[0].voiceLine = this.voiceLine;
    this.selectedStoreConfig[0].address = this.address;
    this.selectedStoreConfig[0].dataLine = this.dataLine;
    this.selectedStoreConfig[0].city = this.city;
    this.selectedStoreConfig[0].chain = this.chain;
    this.selectedStoreConfig[0].state = this.state;
    this.selectedStoreConfig[0].zip = this.zip;
    this.selectedStoreConfig[0].primaryDC = this.primaryDC;
    this.selectedStoreConfig[0].defaultGL = this.defaultGL;
    this.selectedStoreConfig[0].discountGL = this.discountGL;
    this.selectedStoreConfig[0].surchargeGL = this.surchargeGL;
    this.selectedStoreConfig[0].salesTaxGL = this.salesTaxGL;
    this.selectedStoreConfig[0].apAccount = this.apAccount;
    this.selectedStoreConfig[0].division = this.division;
    this.selectedStoreConfig[0].site = this.site;
    this.selectedStoreConfig[0].foodVendor = this.foodVendor;
    this.selectedStoreConfig[0].equipmentVendor = this.equipmentVendor;
    this.selectedStoreConfig[0].departmentNumber = this.departmentNumber;
    this.selectedStoreConfig[0].locationNumber = this.locationNumber;
    this.selectedStoreConfig[0].segments = this.segments;
    this.selectedStoreConfig[0].segmentSeparator = this.segmentSeparator;
    this.selectedStoreConfig[0].exportWithSaparator = this.exportWithSaparator;


    lastValueFrom(this.storeConfigService.updateSystemConfig(this.selectedSystemConfig))
      .then(r => r);
    lastValueFrom(this.storeConfigService.updateStoreConfig(this.selectedStoreConfig[0]))
      .then(r => r);
    lastValueFrom(this.storeConfigService.saveFileData(this.selectedHomeOffice.hoId, this.pkgOld, this.moduleOld, this.newPkg, "AP", this.mySelectionFileNames))
      .then(r => {
        this.dialogService.showSuccessNotification('Update Successful');
      })
  }


  setChanges(dataItem) {
    if(dataItem.assigned) {
      this.mySelectionFileNames.push(dataItem.fileName);
    } else if (!dataItem.assigned) {
      let found = this.mySelectionFileNames.findIndex(x => x === dataItem.fileName);
      this.mySelectionFileNames.splice(found, 1);
    }
  }

  storeValueChange(store: Store) {
    this.selectedStore = store;
    this.populateConfig(store).then(r => r);
  }

  addSegment() {
    const dialogRef = this.dialogService.open({
      type: DialogType.INFO,

      title: 'Add Segment',
      content: AddSegmentComponent,
      actions: [
        {text: 'Cancel', primary: false},
        {text: 'Ok', primary: true},
      ],
      width: 400
    });

    const dialogContent = dialogRef.content.instance;
    dialogRef.result.subscribe(async (answer: any) => {
      let newSegment = dialogContent.newSegment;
      if (answer.text === 'Ok') {
        this.newSegmentArray = [];
        this.newSegment.index = '0';
        this.newSegment.length = newSegment;
        this.newSegmentArray.push(this.newSegment);
        this.selectedStoreConfig[0].segments = this.newSegmentArray;
        lastValueFrom(this.storeConfigService.addSegment(this.selectedStoreConfig)).then(() => {
          this.dialogService.showSuccessNotification('Add Successful');
          this.populateConfig(this.selectedStore).then(r => r);
        });
      }
    });
  }

  deleteSegment() {
    this.selectedStoreConfig[0].segments = this.mySelectionSegments;
    lastValueFrom(this.storeConfigService.deleteSegment(this.selectedStoreConfig)).then(() => {
      this.dialogService.showSuccessNotification('Delete Successful');
      this.mySelectionSegments = [];
      this.populateConfig(this.selectedStore).then(r => r);
    });
  }

  async packageNameValueChange(packageName: Package) {
    if (packageName.pkg !== "Select Package...") {
      this.mySelectionFileNames = [];
      this.fileNames = await this.storeConfigService.getFileNames(packageName.pkg);
      this.gridDataFileNames = this.fileNames;
      if (this.fileNames) {
        this.newPkg = this.fileNames[0].pkg;
      }
      this.gridDataFileNames.forEach(item => {
        if (item.assigned) {
          this.mySelectionFileNames.push(item.fileName);
        }
      });
    } else {
      this.gridDataFileNames = [];
    }
  }

}
